<template>
  <nav id="gnavi" role="navigation" itemscope itemtype="http://schema.org/SiteNavigationElement">
    <div class="trg" @click="trg = !trg">
      <svg v-if="!trg" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M160-269.23v-40h640v40H160ZM160-460v-40h640v40H160Zm0-190.77v-40h640v40H160Z"/></svg>
      <svg v-else class="lg" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="M256-227.69 227.69-256l224-224-224-224L256-732.31l224 224 224-224L732.31-704l-224 224 224 224L704-227.69l-224-224-224 224Z"/></svg>
    </div>
    <transition name="fade">
      <ul class="max" v-show="trg">
        <li itemprop="name">
          <dl>
            <dt data-eng="USER GUIDE"><span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M192 384L88.5 384C63.6 384 48.3 356.9 61.1 335.5L114 247.3C122.7 232.8 138.3 224 155.2 224L250.2 224C326.3 95.1 439.8 88.6 515.7 99.7C528.5 101.6 538.5 111.6 540.3 124.3C551.4 200.2 544.9 313.7 416 389.8L416 484.8C416 501.7 407.2 517.3 392.7 526L304.5 578.9C283.2 591.7 256 576.3 256 551.5L256 448C256 412.7 227.3 384 192 384L191.9 384zM464 224C464 197.5 442.5 176 416 176C389.5 176 368 197.5 368 224C368 250.5 389.5 272 416 272C442.5 272 464 250.5 464 224z"/></svg>คู่มือผู้ใช้</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" class="arr"><path d="M480-357.85 253.85-584 296-626.15l184 184 184-184L706.15-584 480-357.85Z"/></svg></dt>
            <dd>
              <ul>
                <li itemprop="name"><a itemprop="url" href="/advantage">จุดแข็งของ Rocket Wristband<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" class="arr"><path d="m517.85-480-184-184L376-706.15 602.15-480 376-253.85 333.85-296l184-184Z"/></svg></a></li>
              </ul>
            </dd>
          </dl>
        </li>
        <li itemprop="name">
          <dl>
            <dt data-eng="ITEMS">รายการสินค้า<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" class="arr"><path d="M480-357.85 253.85-584 296-626.15l184 184 184-184L706.15-584 480-357.85Z"/></svg></dt>
            <dd>
              <ul>
                <li itemprop="name"><a itemprop="url" href="/products">เลือกจากสินค้าทั้งหมด<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" class="arr"><path d="m517.85-480-184-184L376-706.15 602.15-480 376-253.85 333.85-296l184-184Z"/></svg></a></li>
                <li itemprop="name"><a itemprop="url" href="/purpose">เลือกจากวัตถุประสงค์<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" class="arr"><path d="m517.85-480-184-184L376-706.15 602.15-480 376-253.85 333.85-296l184-184Z"/></svg></a></li>
                <li itemprop="name"><a itemprop="url" href="/price">เลือกจากราคา<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" class="arr"><path d="m517.85-480-184-184L376-706.15 602.15-480 376-253.85 333.85-296l184-184Z"/></svg></a></li>
              </ul>
            </dd>
          </dl>
        </li>
        <li itemprop="name"><a itemprop="url" href="/template" data-eng="TEMPLATE">ฟอร์มออกแบบ<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" class="arr"><path d="m517.85-480-184-184L376-706.15 602.15-480 376-253.85 333.85-296l184-184Z"/></svg></a></li>
        <li itemprop="name"><a itemprop="url" href="/blog/" data-eng="BLOG">บล็อก<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" class="arr"><path d="m517.85-480-184-184L376-706.15 602.15-480 376-253.85 333.85-296l184-184Z"/></svg></a></li>
        <li itemprop="name"><a itemprop="url" href="/voices" data-eng="PORTFOLIO">รวมผลงาน<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" class="arr"><path d="m517.85-480-184-184L376-706.15 602.15-480 376-253.85 333.85-296l184-184Z"/></svg></a></li>
        <li itemprop="name"><a itemprop="url" href="/sample" data-eng="SAMPLE">ขอรับตัวอย่าง<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" class="arr"><path d="m517.85-480-184-184L376-706.15 602.15-480 376-253.85 333.85-296l184-184Z"/></svg></a></li>
        <li class="sp-v"><a href="/contact">สอบถามเพิ่มเติม<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" class="arr"><path d="m517.85-480-184-184L376-706.15 602.15-480 376-253.85 333.85-296l184-184Z"/></svg></a></li>
        <li class="sp-v"><a href="https://www.rocket-wristband.com/" target="_blank" rel="nofollow"><div class="jp"><figure><img src="/images/common/hinomaru.gif" alt="日本語サイト"></figure><span>日本語サイト</span></div><svg xmlns="http://www.w3.org/2000/svg" class="arr" viewBox="0 -960 960 960"><path d="M251.77-254.23 210-296l393.62-394H245.77v-60h460v460h-60v-357.85l-394 393.62Z"/></svg></a></li>
      </ul>
    </transition>
  </nav>
</template>

<style lang="scss" scoped>
nav{
  a{
    &:hover{
      color: module.$sub;
    }
  }
  .trg{
    display: none;
    @media screen and (max-width: module.$phone){
      width: 2.8rem;
      height: var(--head);
      display: block;
      position: fixed;
      top:0;
      right: .8rem;
      @include module.flex();
      align-items: center;
      justify-content: center;
      cursor: pointer;
      svg{
        width: 100%;
        display: block;
        fill: module.$main;
        &.lg{
          transform: scale(1.2);
        }
      }
    }
  }
  > ul{
    &.max{
      padding: 0 1.6rem;
      @media screen and (max-width: module.$tab){
        padding: 0;
      }
    }
    @media screen and (min-width: calc(#{module.$phone} + 1px)){
      display: grid !important;
      grid-template-columns: repeat(6, 1fr);
    }
    @media screen and (max-width: module.$phone){
      position: absolute;
      top: var(--head);
      left: 0;
      width: 100%;
      background: module.$white;
      box-shadow: 0 3.2rem 3.2rem rgba(module.$normal,.32);
    }
    > li{
      position: relative;
      @media screen and (max-width: module.$phone){
        border-bottom: module.$border 1px solid;
      }
      &:before,
      &:after{
        content: '';
        position: absolute;
        top: 50%;
        right: 0;
        width: 1px;
        height: 50%;
        background: module.$border;
        transform: translateY(-50%);
        @media screen and (max-width: module.$tab){
          height: 100%;
        }
      }
      &:before{
        display: none;
      }
      &:first-of-type{
        &:before{
          display: block;
          right: auto;
          left: 0;
        }
      }
      &.sp-v{
        display: none;
        @media screen and (max-width: module.$phone){
          display: block;
          .jp{
            @include module.flex();
            align-items: center;
            justify-content: flex-start;
            figure{
              width: 3.2rem;
              margin: 0 .8rem 0 0;
              border: module.$border 1px solid;
              img{
                width: 100%;
              }
            }
            span{
              display: block;
            }
          }
        }
      }
      .arr{
        display: none;
        @media screen and (max-width: module.$phone){
          display: block;
          position: absolute;
          top: 50%;
          right: 1.2rem;
          transform: translateY(-50%);
          width: 1.6rem;
          opacity: .32;
          transition: all 300ms module.$ease;
        }
      }
      > a,
      dt{
        font-size: .96rem;
        font-weight: 700;
        padding: .6rem;
        display: block;
        text-align: center;
        line-height: 1.6;
        cursor: pointer;
        position: relative;
        @media screen and (max-width: module.$tab){
          font-size: .92rem;
        }
        @media screen and (max-width: module.$phone){
          text-align: left;
          font-size: 1rem;
          padding: 1rem 1.6rem;
        }
        span{
          @include module.flex();
          align-items: center;
          justify-content: center;
          @media screen and (max-width: module.$phone){
            justify-content: flex-start;
          }
          svg{
            width: 1.2rem;
            display: inline-block;
            margin: 0 .4rem 0 0;
            transform: rotateY(180deg);
            fill: module.$sub;
            @media screen and (max-width: module.$tab){
              width: 1rem;
            }
          }
        }
        &::before{
          content: attr(data-eng);
          display: block;
          font-size: .64rem;
          font-weight: 700;
          letter-spacing: .08rem;
          color: module.$sub;
          margin: 0;
          @media screen and (max-width: module.$tab){
            display: none;
          }
        }
      }
      > a{
        &:hover{
          &:after{
            width: 3.2rem;
          }
        }
        &:after{
          content: '';
          width: 0;
          height: .32rem;
          background: module.$sub;
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          transition: width 200ms module.$ease;
        }
      }
      dl{
        position: relative;
        &:hover{
          dd{
            @media screen and (min-width: calc(#{module.$tab} + 1px)){
              grid-template-rows:  minmax(0, 1fr);
            }
          }
        }
        &.active{
          @media screen and (max-width: module.$tab){
            dd{
              grid-template-rows:  minmax(0, 1fr);
            }
          }
          @media screen and (max-width: module.$phone){
            dt{
              .arr{
                transform: translateY(-50%) rotate(180deg);
                fill: module.$main;
                opacity: 1;
              }
            }
            dd{
              grid-template-rows:  minmax(0, 1fr);
            }
          }
        }
        dd{
          width: 100%;
          position: absolute;
          bottom: 1px;
          left: 0;
          transform: translateY(100%);
          display: grid;
          grid-template-rows: minmax(0, 0fr);
          transition: grid-template-rows 200ms module.$ease;
          overflow: hidden;
          box-shadow: 0 1rem 1rem rgba(module.$normal,.12);
          @media screen and (max-width: module.$phone){
            position: relative;
            bottom: auto;
            top: 0;
            transform: translateY(0);
            box-shadow: none;
          }
          > ul{
            background: module.$white;
            padding: 1px 0 0;
            @media screen and (max-width: module.$phone){
              padding: 0;
              border-top: module.$border 1px solid;
            }
            > li{
              border-top: module.$border 1px solid;
              position: relative;
              @media screen and (max-width: module.$phone){
                border-top: none;
                border-bottom: module.$border 1px solid;
                &:last-child{
                  border: none;
                }
              }
              a{
                font-size: .96rem;
                font-weight: 700;
                display: block;
                padding: .8rem 1.2rem;
                text-align: center;
                @media screen and (max-width: module.$phone){
                  background: module.$gray;
                  text-align: left;
                  font-size: 1rem;
                  padding: 1rem 1.6rem;
                }
                .pdf{
                  display: inline-block;
                  background: url(/images/common/icon_pdf.webp) no-repeat left center / 1.1rem;
                  padding: 0 0 0 1.6rem;
                }
              }
            }
          }
        }
      }
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.4s module.$ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>

<script>
export default {
  data: function(){
    return {
      trg: false
    }
  },
  mounted() {
    const dls = document.querySelectorAll('#gnavi dl')
    dls.forEach(dl => {
      dl.addEventListener('click', () => {
        dl.classList.toggle('active')
      })
    })
  }
}
</script>